import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-img-readonly-header',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './img-readonly-header.component.html',
  styleUrls: ['./img-readonly-header.component.css']
})
export class ImgReadonlyHeaderComponent {
  @Input() image: string = '';
  @Input() alt: string = '';
  @Input() title: string = '';
  @Input() subTitle: string | undefined;
  @Input() buttonText: string = '';
  @Input() status?: string;
  @Input() version: string = '';
  @Input() versions: any[] = [];
  @Output() buttonAction: EventEmitter<void> = new EventEmitter<void>();
  @Output() versionChange = new EventEmitter<number>();
  selectedVersion: number;

  getStatusClass(): string {
    switch (this.status) {
      case 'APPROVED':
        return 'aprobado';
      case 'REJECTED':
        return 'rechazado';
      case 'IN_APPROVAL':
        return 'enAprobacion';
      case 'DEPRECATED':
        return 'descontinuado';
      case 'DRAFT':
        return 'borrador';
      default:
        return '';
    }
  }

  getStatusText(): string {
    switch (this.status) {
      case 'APPROVED':
        return 'Aprobado';
      case 'DEPRECATED':
        return 'Descontinuado';
      case 'REJECTED':
        return 'Rechazado';
      case 'IN_APPROVAL':
        return 'En aprobación';
      case 'DRAFT':
        return 'Borrador';
      default:
        return '';
    }
  }
  onVersionChange(event: Event) {
    const selectElement = event.target as HTMLSelectElement;
    const selectedFinancialSetupId = Number(selectElement.value);
    this.versionChange.emit(selectedFinancialSetupId);
  }
}

